<div class="advanced-filter-component">
  <div class="d-flex gap-10 align-items-center filter-card-container">
    <mat-chip-set>
      @for (filter of visibleChips(); track filter.id) {
        <app-advanced-filter-item
          [filter]="filter"
          [apiFilters]="apiFilters()"
          [oneEditOperationAtATimeSubject]="oneEditOperationAtATimeSubject"
          (removeClick)="removeFilter(filter)"
          (hoveredFilterIdentityUpdate)="manager().hoveredFilterIdentity.set($event)"
          (editSubmit)="updateChip(filter, $event)"
          (makeOnHoldChipVisible)="makeOnHoldChipVisible(filter.id)"
          (deleteOnHoldChip)="deleteOnHoldChip(filter.id)"
        />
      }

      <advanced-filter-inputs-toggle-chip
        [oneEditOperationAtATimeSubject]="oneEditOperationAtATimeSubject"
        (addFilter)="addFilter($event)"
        (hoveredFilterIdentityUpdate)="manager().hoveredFilterIdentity.set($event)"
        (makeOnHoldChipVisible)="makeOnHoldChipVisible($event)"
        (deleteOnHoldChip)="deleteOnHoldChip($event)"
      ></advanced-filter-inputs-toggle-chip>
    </mat-chip-set>
  </div>

  @if (isApplyButtonShown()) {
    <div class="d-flex flex-wrap gap-10 align-items-center filter-card-container">
      <button mat-flat-button (click)="apply()">
        {{ 'button.update' | translate }}
      </button>

      @if (isSetAsDefaultButtonShown()) {
        <button mat-stroked-button (click)="apply(true)">
          {{ 'button.setAsDefault' | translate }}
        </button>
      }
      <span class="apply-text">{{ 'system.message.filterCardUpdateTextForWidgets' | translate }}</span>
    </div>
  }
</div>
